import * as Yup from "yup";

const NUMBERONLY = /^[0-9\s]+$/;
const CHARTERONLY = /^[aA-zZZöÖüÜäÄß\s]+$/;
const ALPHANUMERIC = /^[0-9aA-zZöÖüÜäÄß\s]+$/;
const PASSWORD =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-ZöÖüÜäÄß])(?=.*[^A-Za-z0-9]).{8,}$/;

const ACCOUNTHOLDER = /^[\p{L}0-9 \-]+$/u;

export const accountHolderSpecialCharsMessage =
  "Es sind keine Sonderzeichen (z. B. &, :, $) erlaubt.";

const TAX_NUMBER = /^(DE[0-9]+|[0-9]{9,15})$/;

// Using built-in methods

function isVallidTaxNumber() {
  return this.matches(TAX_NUMBER, {
    message:
      "Bitte achten Sie auf das richtige Format. Verwenden Sie bitte nur DE gefolgt von Ziffern oder eine Kombination aus Ziffern und /",
    excludeEmptyStrings: true,
  }).required("Steuernummer erforderlich.");
}

// Using built-in methods
function isValidAccountHolder() {
  return this.required("Kontoinhaber*in ist notwendig.")
    .min(4, "Der Kontoinhaber muss mindestens vier Zeichen lang sein.")
    .matches(ACCOUNTHOLDER, {
      message: accountHolderSpecialCharsMessage,
      excludeEmptyStrings: true,
    });
}

export function sanitizeAccountHolderInput(value) {
  return (value ?? "").replace(/[^\p{L}0-9 \-]/gu, "");
}

function isValidPersonName() {
  return this.matches(ACCOUNTHOLDER, {
    message: accountHolderSpecialCharsMessage,
    excludeEmptyStrings: true,
  });
}

function isValidPassword() {
  return this.matches(PASSWORD, {
    message:
      "Passwort muss mindestens 8 Zeichen lang, einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Sonderzeichen enthalten",
    excludeEmptyStrings: true,
  }).required("Bitte geben Sie den Kontoinhaber ein.");
}
function isCharterOnly() {
  return this.matches(CHARTERONLY, {
    message: "nur Zeichen erlaubt.",
    excludeEmptyStrings: true,
  });
}
function isAlphaNumeric() {
  return this.matches(ALPHANUMERIC, {
    message: "nur Zahl und Zeichen erlaubt.",
    excludeEmptyStrings: true,
  });
}

function isNumberOnly() {
  return this.matches(NUMBERONLY, {
    message: "Nur Nummer ist erlaubt.",
    excludeEmptyStrings: true,
  });
}

function isValidPostalCode() {
  return this.matches(NUMBERONLY, {
    message: "Nur Nummer ist erlaubt.",
    excludeEmptyStrings: false,
  }).test("len", "PLZ ist nicht korrekt.", (val) => val?.length === 5);
}
Yup.addMethod(Yup.string, "isValidAccountHolder", isValidAccountHolder);
Yup.addMethod(Yup.string, "isValidPersonName", isValidPersonName);
Yup.addMethod(Yup.string, "isValidPassword", isValidPassword);
Yup.addMethod(Yup.string, "isCharterOnly", isCharterOnly);
Yup.addMethod(Yup.string, "isAlphaNumeric", isAlphaNumeric);
Yup.addMethod(Yup.string, "isNumberOnly", isNumberOnly);
Yup.addMethod(Yup.string, "isValidPostalCode", isValidPostalCode);
Yup.addMethod(Yup.string, "isVallidTaxNumber", isVallidTaxNumber);
